(function () {
  // ───────────────────────────────────────────────────────────────────
  // Stage 1b: localStorage + customer metafield sync.
  // Logged-in customers: list syncs across devices via the worker.
  // Guests: localStorage only. On login, guest list merges into the
  // customer's list automatically.
  // ───────────────────────────────────────────────────────────────────

  var customerId  = window.__wishlistCustomerId;
  var STORAGE_KEY = customerId ? 'wishlist_' + customerId : 'wishlist_guest';
  var GUEST_KEY   = 'wishlist_guest';
  var SYNC_URL    = '/apps/customer-features/wishlist';

  // ── localStorage primitives ───────────────────────────────────────

  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (_) { return []; }
  }

  function save(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function has(productId) {
    return load().some(function (p) { return String(p.id) === String(productId); });
  }

  function add(product) {
    var items = load();
    if (!items.some(function (p) { return String(p.id) === String(product.id); })) {
      items.push(product);
      save(items);
    }
  }

  function remove(productId) {
    save(load().filter(function (p) { return String(p.id) !== String(productId); }));
  }

  function getAll() { return load(); }

  // ── Merge helpers ─────────────────────────────────────────────────

  function mergeUnique(/* ...lists */) {
    var seen = {};
    var out = [];
    for (var i = 0; i < arguments.length; i++) {
      var list = arguments[i];
      if (!Array.isArray(list)) continue;
      for (var j = 0; j < list.length; j++) {
        var item = list[j];
        if (!item || item.id == null) continue;
        var id = String(item.id);
        if (seen[id]) continue;
        seen[id] = true;
        out.push(item);
      }
    }
    return out;
  }

  function sameProducts(a, b) {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    var aIds = {};
    for (var i = 0; i < a.length; i++) aIds[String(a[i].id)] = true;
    for (var j = 0; j < b.length; j++) if (!aIds[String(b[j].id)]) return false;
    return true;
  }

  // ── Server sync ───────────────────────────────────────────────────

  function pushToServer(items) {
    if (!customerId) return Promise.resolve();
    return fetch(SYNC_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ wishlist: items }),
    }).catch(function () { /* silent — localStorage still works */ });
  }

  function syncOnLoad() {
    if (!customerId) return;

    fetch(SYNC_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.wishlist)) return;

        var server = data.wishlist;
        var local  = load();
        var guest  = [];
        try { guest = JSON.parse(localStorage.getItem(GUEST_KEY) || '[]'); }
        catch (_) {}

        // Union of all three sources, deduped by product id
        var merged = mergeUnique(server, local, guest);

        // If merged differs from server, push it back
        if (!sameProducts(server, merged)) {
          pushToServer(merged);
        }

        // Update localStorage with the merged list
        save(merged);

        // Clear the guest bucket — it's now folded into the customer's list
        if (STORAGE_KEY !== GUEST_KEY) {
          localStorage.removeItem(GUEST_KEY);
        }

        updateButtons();
        updateHeaderCount();
      })
      .catch(function () { /* silent */ });
  }

  // ── UI updates ────────────────────────────────────────────────────

  function updateButtons() {
    document.querySelectorAll('.js-wishlist-btn').forEach(function (btn) {
      var active = has(btn.dataset.productId);
      btn.classList.toggle('wishlist-heart--active', active);
      btn.classList.toggle('wishlist-button--active', active);
      btn.setAttribute('aria-label', active ? 'Remove from favourites' : 'Save to favourites');
    });
  }

  function updateHeaderCount() {
    var bubble  = document.querySelector('[data-wishlist-bubble]');
    var numEl   = document.querySelector('[data-wishlist-count]');
    var labelEl = document.querySelector('[data-wishlist-count-label]');
    if (!bubble || !numEl) return;

    var count = load().length;
    if (count > 0) {
      bubble.removeAttribute('hidden');
      numEl.textContent = count < 100 ? String(count) : '99+';
      if (labelEl) labelEl.textContent = count + ' items in favourites';
    } else {
      bubble.setAttribute('hidden', '');
    }
  }

  function showToast(btn, message) {
    document.querySelectorAll('.wishlist-toast').forEach(function (t) { t.remove(); });

    var toast = document.createElement('span');
    toast.className = 'wishlist-toast';
    toast.textContent = message;
    document.body.appendChild(toast);

    var rect = btn.getBoundingClientRect();
    toast.style.left   = (rect.left + rect.width / 2) + 'px';
    toast.style.bottom = (window.innerHeight - rect.top + 8) + 'px';

    requestAnimationFrame(function () {
      toast.classList.add('wishlist-toast--visible');
    });

    setTimeout(function () {
      toast.classList.remove('wishlist-toast--visible');
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 250);
    }, 1800);
  }

  // ── Click handler — debounced server push ─────────────────────────

  var pushTimer = null;
  function schedulePush() {
    if (!customerId) return;
    if (pushTimer) clearTimeout(pushTimer);
    pushTimer = setTimeout(function () { pushToServer(load()); }, 400);
  }

  function bindButtons() {
    document.querySelectorAll('.js-wishlist-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var product = {
          id:    this.dataset.productId,
          title: this.dataset.productTitle,
          url:   this.dataset.productUrl,
          image: this.dataset.productImage,
          price: this.dataset.productPrice,
          type:  this.dataset.productType || '',
          tags:  this.dataset.productTags || '',
        };
        var wasSaved = has(product.id);
        if (wasSaved) {
          remove(product.id);
          showToast(this, 'Removed from favourites');
        } else {
          add(product);
          showToast(this, 'Added to favourites');
        }
        updateButtons();
        updateHeaderCount();
        schedulePush();
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
      });
    });
  }

  // ── Public API ────────────────────────────────────────────────────

  window.Wishlist = {
    getAll: getAll,
    add: function (p) { add(p); updateButtons(); updateHeaderCount(); schedulePush(); },
    remove: function (id) { remove(id); updateButtons(); updateHeaderCount(); schedulePush(); },
    has: has,
    refreshUI: function () { updateButtons(); updateHeaderCount(); },
    sync: syncOnLoad,
  };

  // ── Bootstrap ─────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    bindButtons();
    updateButtons();
    updateHeaderCount();
    syncOnLoad();
  });

  document.addEventListener('wishlist:updated', updateHeaderCount);

  // ───────────────────────────────────────────────────────────────────
  // Notify-me (back-in-stock) — logged-in customers only.
  // Stores entries in the customer's `notify.subscriptions` metafield via
  // the worker. No localStorage fallback; logged-out users see a login
  // link rendered server-side and never reach this code.
  // ───────────────────────────────────────────────────────────────────

  var NOTIFY_URL = '/apps/customer-features/notify';
  var notifyState = { loaded: false, subscriptions: [], pending: {} };

  function notifyHasVariant(variantId) {
    return notifyState.subscriptions.some(function (s) {
      return String(s.variantId) === String(variantId);
    });
  }

  function renderNotifyButtons() {
    document.querySelectorAll('.js-notify-me').forEach(function (root) {
      if (root.dataset.loggedIn !== 'true') return;
      var btn = root.querySelector('.js-notify-me-toggle');
      var hint = root.querySelector('.notify-me__hint');
      if (!btn) return;
      var active = notifyHasVariant(root.dataset.variantId);
      btn.classList.toggle('notify-me__button--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (hint) {
        if (active) hint.removeAttribute('hidden');
        else hint.setAttribute('hidden', '');
      }
    });

    document.querySelectorAll('.js-notify-me-card').forEach(function (btn) {
      var active = notifyHasVariant(btn.dataset.variantId);
      btn.classList.toggle('notify-me-card--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        active ? 'Notifications on — click to remove' : 'Notify me when back in stock'
      );
    });
  }

  function loadSubscriptions() {
    if (!customerId) return Promise.resolve();
    return fetch(NOTIFY_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && Array.isArray(data.subscriptions)) {
          notifyState.subscriptions = data.subscriptions;
          notifyState.loaded = true;
          renderNotifyButtons();
        }
      })
      .catch(function () { /* silent — buttons stay in default state */ });
  }

  function buildSubscriptionPayload(root) {
    if (!root || !root.dataset) return null;
    return {
      variantId:     root.dataset.variantId,
      productId:     root.dataset.productId,
      productTitle:  root.dataset.productTitle,
      productHandle: root.dataset.productHandle,
      productUrl:    root.dataset.productUrl,
      productImage:  root.dataset.productImage,
      variantTitle:  root.dataset.variantTitle,
    };
  }

  // After a successful marketing subscribe, hide the opt-in everywhere on the
  // page so the customer doesn't see it again until next page load.
  function hideMarketingOptIns() {
    document.querySelectorAll('.js-notify-me-optin').forEach(function (el) {
      el.setAttribute('hidden', '');
    });
  }

  function notifySubscribe(root) {
    var payload = buildSubscriptionPayload(root);
    if (!payload) return;
    var variantId = payload.variantId;
    if (!variantId || notifyState.pending[variantId]) return;
    notifyState.pending[variantId] = true;

    var marketingBox = root.querySelector('.js-notify-me-marketing');
    var subscribeMarketing = !!(marketingBox && marketingBox.checked);
    if (subscribeMarketing) payload.subscribeMarketing = true;

    // Optimistic UI
    notifyState.subscriptions = notifyState.subscriptions
      .filter(function (s) { return String(s.variantId) !== String(variantId); })
      .concat([payload]);
    renderNotifyButtons();

    fetch(NOTIFY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && Array.isArray(data.subscriptions)) {
          notifyState.subscriptions = data.subscriptions;
        }
        if (data && data.marketingSubscribed) hideMarketingOptIns();
      })
      .catch(function () { /* leave optimistic state in place */ })
      .then(function () {
        delete notifyState.pending[variantId];
        renderNotifyButtons();
      });
  }

  function notifyUnsubscribe(root) {
    if (!root || !root.dataset) return;
    var variantId = root.dataset.variantId;
    if (!variantId || notifyState.pending[variantId]) return;
    notifyState.pending[variantId] = true;

    notifyState.subscriptions = notifyState.subscriptions
      .filter(function (s) { return String(s.variantId) !== String(variantId); });
    renderNotifyButtons();

    fetch(NOTIFY_URL, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ variantId: variantId }),
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && Array.isArray(data.subscriptions)) {
          notifyState.subscriptions = data.subscriptions;
        }
      })
      .catch(function () { /* leave optimistic state in place */ })
      .then(function () {
        delete notifyState.pending[variantId];
        renderNotifyButtons();
      });
  }

  function bindNotifyButtons() {
    document.querySelectorAll('.js-notify-me').forEach(function (root) {
      if (root.dataset.notifyBound === '1') return;
      root.dataset.notifyBound = '1';
      var btn = root.querySelector('.js-notify-me-toggle');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (notifyHasVariant(root.dataset.variantId)) {
          notifyUnsubscribe(root);
        } else {
          notifySubscribe(root);
        }
      });
    });

    document.querySelectorAll('.js-notify-me-card').forEach(function (btn) {
      if (btn.dataset.notifyBound === '1') return;
      btn.dataset.notifyBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (notifyHasVariant(btn.dataset.variantId)) {
          notifyUnsubscribe(btn);
        } else {
          notifySubscribe(btn);
        }
      });
    });
  }

  function refreshNotify() {
    bindNotifyButtons();
    if (notifyState.loaded) renderNotifyButtons();
  }

  // Replace the inner HTML of every NotifyMe-* wrapper from a freshly-fetched
  // product Document. Craft's variant-change pub/sub provides the new HTML so
  // we can mirror what the theme does for price/SKU.
  function syncNotifyFromHtml(sourceDoc) {
    if (!sourceDoc || !sourceDoc.querySelectorAll) return;
    document.querySelectorAll('[id^="NotifyMe-"]').forEach(function (dest) {
      var source = sourceDoc.getElementById(dest.id);
      if (source) dest.innerHTML = source.innerHTML;
    });
    refreshNotify();
  }

  window.NotifyBackInStock = {
    refreshUI: refreshNotify,
    reload: loadSubscriptions,
    has: notifyHasVariant,
  };

  document.addEventListener('DOMContentLoaded', function () {
    bindNotifyButtons();
    if (customerId) loadSubscriptions();

    // Subscribe to Craft's pub/sub when the variant changes. The theme exposes
    // `subscribe` and `PUB_SUB_EVENTS` as globals from pubsub.js + constants.js.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        syncNotifyFromHtml(event && event.data && event.data.html);
      });
    }
  });
})();
